import React from 'react'
import './button.css'

const Button = () => {
    return (
            <div className="button__toggle">
            <label className="toggle">
                <input className="toggle-checkbox" type="checkbox" align='center'/>
                    MALE
                    <div className="toggle-switch"></div>
                    <span className="toggle-label"></span>
                    FEMALE
            </label>
            </div>
    )
}

export default Button